export default __webpack_public_path__ + "static/media/icon7.c04a048f.svg";